import {createStore} from 'vuex';
import mutations from './mutations.js';
import Actions from './actions.js';

export default (authSupport, serviceClient, messageService) => {
  return createStore({
    state: {
      accessToken: undefined,
      libraries: [],
      templates: [],
      mergeTagsSources: [],
      currentPage: 1,
      templateData: {},
      templateId: undefined,
      destinationLibrary: undefined,
      templateName: '',
      newTemplateName: '',
      editorOpen: false,
      error: undefined,
      pageCount: 0,
      customer: undefined,
      newsletter: undefined,
      conflict: {},
      success: false,
      dirtyTemplate: '',
      dirtyTemplateHTML: '',
      openSaveModal: false,
      loadingTemplates: false,
      loadingLibraries: false,
      loadingTemplate: false,
      savingTemplate: false,
      showUseModal: false,
      duplicateTemplate: false,
      duplicateTemplateData: {},
      loadApplication: undefined,
      hideUseButton: false,
      customMessage: undefined,
      userDb: undefined,
      mergeTagsSource: undefined,
      displayConditionsOpen: false,
      displayConditionSaved: false,
      dynamicContents: false,
      dynamicContentsOpen: false,
      dynamicContentsSaved: false,
      saveRowOpen: false,
      externalContentUrlsOpen: false,
      externalContentUrlsModified: false,
      filterTemplateName: '',
      customerTags: [],
      selectedTags: [],
      pendingTags: [],
      deleteTagsModal: false,
      info: undefined,
      warning: undefined,
      section: 'templates',
      isCustomerCare: false,
      htmlTest: '',
      showTestModal: false
    },
    mutations,
    getters: {
      showBackToWork: state => !!state.dirtyTemplate,
      isFirstLibraryActive: state => state.libraries?.[0]?.active ?? false,
      isFourthLibraryActive: state => state.libraries?.[3]?.active ?? false,
      canSelectDestinationLibrary: state =>
        state.libraries?.some(l => l.id !== 'MINE' && !l.readOnly) ?? false,
      activeLibrary: state => state.libraries?.find(l => l.active === true)
    },
    actions: Actions(authSupport, serviceClient, messageService)
  });
};
